import { ThemeToggle } from '@/src/components/ui/molecules/Header';
import { UserButton } from '@/src/components/ui/organisms/Header/UserButton';
import { LOGO_SVG } from '@/src/constants/common';
import { RoutePath } from '@/src/RoutePath';
import { Header, Link, SpaceBetween } from '@amzn/awsui-components-react';
import styles from './MobileHeader.module.scss';

export const MobileHeader: React.FC = () => {
  const JamLogo = () => {
    return (
      <Link href={RoutePath.ROOT}>
        <div className={styles.jamLogoContainer}>
          <img src={LOGO_SVG} alt="AWS" className={styles.jamLogo} />
          <Header>Jam</Header>
        </div>
      </Link>
    );
  };

  return (
    <div className={styles.nav}>
      <JamLogo />
      <SpaceBetween size="s" direction="horizontal" alignItems="center">
        <ThemeToggle />
        <UserButton />
      </SpaceBetween>
    </div>
  );
};
